import { IBid } from 'Shared/Types/bid';
import { getBid, getBidList, assignBid } from './reducer';
import { RootState } from 'Redux/store';
import { createSlice } from '@reduxjs/toolkit';

interface IBidState {
  current: IBid | null;
  list: IBid[];
  count: number;
  error?: string | null;
  loading: boolean;
}

const initialState: IBidState = {
  current: null,
  list: [],
  count: 0,
  error: null,
  loading: false,
};

const bidSlice = createSlice({
  name: 'bid',
  initialState,
  reducers: {
    resetCurrentBids: (state) => {
      state.current = null;
      state.list = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBidList.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getBidList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(getBidList.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      const { count, results } = action.payload;
      state.count = count;
      state.list = results || [];
    });

    builder.addCase(getBid.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getBid.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(getBid.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.current = action.payload;
    });

    builder.addCase(assignBid.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(assignBid.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(assignBid.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
  },
});

export const { resetCurrentBids } = bidSlice.actions;

export const selectBidLoading = (state: RootState) => state.bid.loading;
export const selectBidError = (state: RootState) => state.bid.error;
export const selectBidList = (state: RootState) => state.bid.list;
export const selectBidCount = (state: RootState) => state.bid.count;
export const selectCurrentBid = (state: RootState) => state.bid.current;

export default bidSlice;
